import { render, staticRenderFns } from "./ApkDownload.vue?vue&type=template&id=49a14330&"
import script from "./ApkDownload.vue?vue&type=script&lang=js&"
export * from "./ApkDownload.vue?vue&type=script&lang=js&"
import style0 from "./ApkDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports